module.exports = __webpack_public_path__ + "static/media/img-ask-to-apply@3x.1168a5ff.png";